module.exports = __webpack_public_path__ + "static/assets/05174f0556825619a0250d0179c62534.svg";